(() => {
  let observer;
  let desktopObservers = [];
  let menuButton;
  let menuPanel;

  function updateMenuState() {
    if (!menuButton || !menuPanel) return;
    const expanded = getComputedStyle(menuPanel).display !== 'none';
    menuButton.setAttribute('aria-expanded', String(expanded));
  }

  function bindNavigation() {
    if (observer) observer.disconnect();
    desktopObservers.forEach((item) => item.disconnect());
    desktopObservers = [];
    document.querySelectorAll('.main-nav').forEach((navigation) => {
      const syncDropdowns = () => {
        navigation.querySelectorAll('.dropdown_link[data-dropdown-rel]').forEach((trigger) => {
          const panel = [...navigation.querySelectorAll('[data-dropdown]')].find((item) =>
            item.getAttribute('data-dropdown') === trigger.getAttribute('data-dropdown-rel'));
          if (panel) trigger.setAttribute('aria-expanded', String(getComputedStyle(panel).display !== 'none'));
        });
      };
      const desktopObserver = new MutationObserver(syncDropdowns);
      desktopObserver.observe(navigation, { subtree: true, attributes: true, attributeFilter: ['style', 'class'], childList: true });
      desktopObservers.push(desktopObserver);
      syncDropdowns();
    });
    menuButton = document.querySelector('.seveneye-mobile-nav');
    menuPanel = document.querySelector('#header [data-dropdown="mobile_menu"]');
    if (!menuButton || !menuPanel) return;
    observer = new MutationObserver(updateMenuState);
    observer.observe(menuPanel, { attributes: true, attributeFilter: ['style', 'class'] });
    updateMenuState();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const navigation = event.target.closest('.main-nav');
    if (navigation) {
      const trigger = navigation.querySelector('.dropdown_link[aria-expanded="true"]');
      if (trigger) {
        event.preventDefault();
        document.documentElement.click();
        trigger.focus();
        return;
      }
    }
    if (!menuButton || menuButton.getAttribute('aria-expanded') !== 'true') return;
    if (!document.querySelector('#header')?.contains(event.target)) return;
    event.preventDefault();
    menuButton.click();
    menuButton.focus();
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.id === 'shopify-section-header') bindNavigation();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.id !== 'shopify-section-header') return;
    if (observer) observer.disconnect();
    desktopObservers.forEach((item) => item.disconnect());
    desktopObservers = [];
    menuButton = null;
    menuPanel = null;
  });

  const headerCloneObserver = new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) =>
      node.nodeType === 1 && (node.matches('.main-nav') || node.querySelector('.main-nav'))))) {
      bindNavigation();
    }
  });
  headerCloneObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindNavigation, { once: true });
  } else {
    bindNavigation();
  }
})();
